import { AVAILABLE_TEMPLATES } from 'constants/templates';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useResumeStore from 'store/resume';
import TemplateLayout from 'layouts/TemplateLayout';
import './styles.scss';

const ResumePreview: React.FC = () => {
	const { slug: templateSlug } = useParams();
	const resumeData: any = useResumeStore((state) => state?.resumeData);

	const { component: Template, styles } = useMemo(
		() =>
			AVAILABLE_TEMPLATES.find((template: any) => template.id === Number(templateSlug)) as {
				component: React.ComponentType<any>;
				styles: { [key: string]: any };
			},
		[templateSlug],
	);

	return (
		<div className="template-preview-area d-flex align-items-center justify-content-center">
			<div id="resume-preview" className="template-preview-area-inner position-absolute">
				<TemplateLayout>
					<Template resumeData={resumeData} styles={styles} />
				</TemplateLayout>
			</div>
		</div>
	);
};

export default React.memo(ResumePreview);
